import {
  FormControlLabel,
  FormControl,
  FormGroup,
  Tooltip,
} from "@mui/material";
import { DocumentScope } from "protogen/documents_pb";
import Checkbox from "../common/Checkbox";
import DropdownMenu from "components/common/DropdownMenu";
import { Settings, Info } from "lucide-react";

export default ({
  onFormInstanceScopeChange,
  formInstanceScope,
  formNotifications,
  onFormNotificationsChange,
  multiInstance,
  onMultiInstanceChange,
}: {
  onScopeChange: (scope: DocumentScope) => void;
  onFormInstanceScopeChange: (scope: string) => void;
  formInstanceScope?: string;
  formNotifications: string[];
  onFormNotificationsChange: (notifications: string[]) => void;
  multiInstance: boolean;
  onMultiInstanceChange: (multiInstance: boolean) => void;
}) => {
  const isMemberOnly = formInstanceScope === "family-private";

  return (
    <DropdownMenu
      keepOpenOnItemClick={true}
      disabled={false}
      buttonContent={<Settings size={20} stroke="#6B6E7B" />}
      dropdownIcon={false}
      variant="text"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      options={[
        {
          title: (
            <FormControl component="fieldset">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isMemberOnly}
                      onChange={(e) => {
                        onFormInstanceScopeChange(
                          e.target.checked ? "family-private" : "private",
                        );
                      }}
                    />
                  }
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      Private results
                      <Tooltip title="Only members and admins will be able to see the results of this form, not their advisors.">
                        <span style={{ marginLeft: 6, display: "flex" }}>
                          <Info size={16} stroke="#6B6E7B" />
                        </span>
                      </Tooltip>
                    </span>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formNotifications.includes("push")}
                      onChange={(e) => {
                        const isEnabled = e.target.checked;
                        const updatedNotifications = isEnabled
                          ? [...formNotifications, "push"]
                          : formNotifications.filter((n) => n !== "push");
                        onFormNotificationsChange(updatedNotifications);
                      }}
                    />
                  }
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      Push notifications
                      <Tooltip title="Send a push notification when this form is updated or submitted.">
                        <span style={{ marginLeft: 6, display: "flex" }}>
                          <Info size={16} stroke="#6B6E7B" />
                        </span>
                      </Tooltip>
                    </span>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={multiInstance}
                      onChange={(e) => {
                        onMultiInstanceChange(e.target.checked);
                      }}
                    />
                  }
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      Multiple responses
                      <Tooltip title="Allow users to submit this form more than once.">
                        <span style={{ marginLeft: 6, display: "flex" }}>
                          <Info size={16} stroke="#6B6E7B" />
                        </span>
                      </Tooltip>
                    </span>
                  }
                />
              </FormGroup>
            </FormControl>
          ),
          onClick: (e) => {
            e.stopPropagation();
          },
        },
      ]}
      sx={{ minWidth: "auto" }}
    />
  );
};
